import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../common/store/generic.selectors';
import { ChequeRemittanceModel, chequeRemittanceFeatureKey } from './types';
import { IChequeRemittanceState } from './cheque-remittance.reducer';
import { IAccountingState } from '../accounting/accounting.reducer';

const chequeRemittanceFeatureState =
  createFeatureSelector<IChequeRemittanceState>(chequeRemittanceFeatureKey);

export const chequeRemittanceSelectors = {
  getById: createApiCallSelectors<
    ChequeRemittanceModel,
    IChequeRemittanceState
  >(chequeRemittanceFeatureState, 'getById'),
  createInstance: createApiCallSelectors<
    ChequeRemittanceModel,
    IChequeRemittanceState
  >(chequeRemittanceFeatureState, 'createInstance'),
  add: createApiCallSelectors<ChequeRemittanceModel, IChequeRemittanceState>(
    chequeRemittanceFeatureState,
    'add',
  ),
  delete: createApiCallSelectors<boolean, IChequeRemittanceState>(
    chequeRemittanceFeatureState,
    'delete',
  ),
  deleteFromList: createApiCallSelectors<boolean, IChequeRemittanceState>(
    chequeRemittanceFeatureState,
    'deleteFromList',
  ),
  getChequeRemittancePdf: createApiCallSelectors<any, IChequeRemittanceState>(
    chequeRemittanceFeatureState,
    'getChequeRemittancePdf',
  ),
};
